import { render, staticRenderFns } from "./WaterWorksVisualization.vue?vue&type=template&id=2cbc8fe8&scoped=true"
import script from "./WaterWorksVisualization.vue?vue&type=script&lang=js"
export * from "./WaterWorksVisualization.vue?vue&type=script&lang=js"
import style0 from "./WaterWorksVisualization.vue?vue&type=style&index=0&id=2cbc8fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc8fe8",
  null
  
)

export default component.exports